'use client'

import { ListPagePerformanceLifecycle } from '@/hooks/home/ListPagePerformanceLifecycle'
import { usePagePerformanceLifecycle } from '@/hooks/usePagePerformanceLifecycle'

export const useListPagePerformanceLifecycle =
  (): ListPagePerformanceLifecycle | null => {
    const lifecycle = usePagePerformanceLifecycle()
    return lifecycle instanceof ListPagePerformanceLifecycle ? lifecycle : null
  }
